<script setup lang="ts">
import { RouterLink } from 'vue-router'
import GuideList from '@motexa/user-guide/GuideList.vue'
import '@motexa/user-guide/style.css'
import { useSiteLocale } from '../composables/useSiteLocale'
const { currentLocale } = useSiteLocale()
const development = import.meta.env.DEV
</script>

<template>
  <div class="simple-page guide-surface website-guide guide-overview">
    <header class="guide-site-hero">
      <span class="guide-site-kicker">MOTEXA RIDE</span>
      <h1>{{ currentLocale === 'zh-CN' ? '使用教程' : 'User guide' }}</h1>
      <p>{{ currentLocale === 'zh-CN' ? '从第一次连接到每一段骑行，按自己的节奏了解各项功能。' : 'From your first connection to every ride, learn each feature at your own pace.' }}</p>
    </header>
    <GuideList :locale="currentLocale" base="/docs" />
    <aside class="guide-sdk-entry">
      <span>{{ currentLocale === 'zh-CN' ? '面向创作者' : 'For creators' }}</span>
      <RouterLink to="/docs/developers">{{ currentLocale === 'zh-CN' ? '主题开发 SDK 与调试器' : 'Theme SDK and debugger' }} <span aria-hidden="true">→</span></RouterLink>
      <a href="https://github.com/shj56166/Motexa#readme" target="_blank" rel="noopener noreferrer">{{ currentLocale === 'zh-CN' ? 'GitHub 项目说明与发布资料 ↗' : 'Project overview and releases on GitHub ↗' }}</a>
    </aside>
    <RouterLink v-if="development" class="guide-preview-link" to="/docs/__preview">{{ currentLocale === 'zh-CN' ? '开发预览：教程排版样例' : 'Development preview: layout sample' }}</RouterLink>
  </div>
</template>

<style scoped>
.guide-overview { max-width: 820px; }
.guide-sdk-entry { display: grid; gap: .5rem; margin-top: 3rem; padding: 1.2rem 0; border-top: 1px solid var(--guide-line); }
.guide-sdk-entry > span { font-size: .8rem; color: var(--guide-muted); }
.guide-sdk-entry a, .guide-preview-link { color: var(--guide-link); font-size: .9rem; }
.guide-preview-link { display: inline-block; margin-top: 1.5rem; }
</style>
